module.exports = __webpack_public_path__ + "img/hex-image-full.7ecbe0aa.png";